import "./PrivacyPolicy.css";

const PrivacyPolicy = () => (
  <main className="legal-page">
    <div className="container">
      <h1>Privacy Policy</h1>
      <p>Last Updated: June 2026</p>
      <p>Trainosys (“we”, “our”, “us”) respects your privacy.</p>
      <p>
        This Privacy Policy explains how information is collected and used through{" "}
        <a href="https://trainosys.sg" target="_blank" rel="noreferrer">
          https://trainosys.sg
        </a>.
      </p>
      <h2>Information We Collect</h2>
      <p>We may collect:</p>
      <ul><li>Name</li><li>Email address</li><li>Phone number</li><li>Company information</li><li>Course inquiries</li><li>Website analytics</li></ul>
      <h2>How We Use Information</h2>
      <p>Information may be used to:</p>
      <ul><li>Respond to inquiries</li><li>Deliver training services</li><li>Improve website experience</li><li>Analyze website usage</li><li>Provide support</li></ul>
      <h2>Cookies</h2>
      <p>Trainosys uses cookies and analytics technologies to improve performance and user experience.</p>
      <p>Users may disable cookies through browser settings.</p>
      <h2>Data Protection</h2>
      <p>Reasonable administrative and technical safeguards are implemented to protect information.</p>
      <h2>Third-Party Services</h2>
      <p>We may use:</p>
      <ul><li>Google Analytics</li><li>CAPTCHA services</li><li>Hosting providers</li><li>Communication platforms</li></ul>
      <p>These providers maintain their own privacy policies.</p>
      <h2>Data Retention</h2>
      <p>Information is retained only as long as necessary for business and legal purposes.</p>
      <h2>User Rights</h2>
      <p>Users may request:</p>
      <ul><li>Access</li><li>Correction</li><li>Deletion</li><li>Data inquiries</li></ul>
      <h2>Policy Updates</h2>
      <p>This Privacy Policy may be updated periodically.</p>
      <h2>Contact</h2>
      <p>Website:<br /><a href="https://trainosys.sg" target="_blank" rel="noreferrer">https://trainosys.sg</a></p>
      <p>Email:<br /><a href={`mailto:${["inquiry", "@", "trainosys.com"].join("")}`}>inquiry@trainosys.com</a></p>
    </div>
  </main>
);

export default PrivacyPolicy;
